import React from 'react';
import { useT } from '../i18n';
import PageSEO from './common/PageSEO';

const T = {
  es: {
    title: 'Política de Privacidad',
    effective: 'Efectiva desde el 25 de febrero de 2022',
    summaryTitle: 'Resumen de Nuestra Política de Privacidad',
    summaryText: 'Esta es un resumen de nuestra nueva política de privacidad, que se aplica a todos los sitios web de Cadenia vinculados aquí y a todos los productos y servicios ofrecidos en dichos sitios web. La política detallada sigue la misma estructura que este resumen y constituye el documento legal real.',
    commitmentTitle: 'Nuestro Compromiso con la Privacidad',
    commitmentText: 'Blue Visibility Tech (marca Cadenia) nunca ha vendido su información a terceros con fines publicitarios, ni obtenemos beneficios mostrándole anuncios de terceros. No tenemos intención de hacerlo en el futuro. Esta política explica qué información recopilamos de usted, qué hacemos con ella, quién puede acceder a ella y qué puede hacer al respecto.',
    controllerTitle: 'Responsable del Tratamiento',
    controllerIdentityLabel: 'Identidad y datos de contacto del responsable:',
    controllerIdentity: 'Blue Visibility Tech S.L.U. NIF B09726571',
    addressLabel: 'Dirección:',
    controllerAddress: 'Calle Princesa 31, 2º Madrid',
    dpoLabel: 'Datos de contacto del delegado de protección de datos:',
    dpoName: 'Jesús Santín',
    part1Title: 'Parte I – Información que Blue Visibility Tech Recopila y Controla',
    collectTitle: 'Qué Información Recopila Blue Visibility Tech',
    collectText: 'Solo recopilamos la información que realmente necesitamos. Parte de esta información son datos que usted nos proporciona activamente cuando registra una cuenta, se inscribe en un evento, solicita atención al cliente o realiza una integración técnica de datos. Almacenamos su nombre e información de contacto, pero no almacenamos números de tarjetas de crédito (excepto con su permiso y en uno de nuestros portales de pago seguros).',
    providedTitle: 'Información que Usted nos Proporciona',
    providedItems: [
      { label: 'Registro de Cuenta:', text: 'Nombre, número de contacto, dirección de correo electrónico, nombre de la empresa y país' },
      { label: 'Registros de Eventos:', text: 'Información enviada al registrarse en eventos, suscribirse a boletines o descargar materiales' },
      { label: 'Información de Pago:', text: 'Nombre, información de contacto y datos de tarjeta de crédito o cuenta bancaria' },
      { label: 'Testimonios:', text: 'Nombre y otra información personal cuando autoriza testimonios' }
    ],
    autoTitle: 'Información que Recopilamos Automáticamente',
    autoItems: [
      { label: 'Información del Navegador y Dispositivo:', text: 'Dirección IP, tipo de navegador, preferencia de idioma, zona horaria' },
      { label: 'Cookies y Tecnologías de Seguimiento:', text: 'Para identificar usuarios y mejorar la experiencia del usuario' },
      { label: 'Registros de Aplicación:', text: 'Información sobre cómo los usuarios utilizan nuestros productos y servicios' }
    ],
    usageTitle: 'Qué Hacemos con su Información',
    usageText: 'Utilizamos su información para proporcionar los servicios que solicitó, crear y mantener sus cuentas, y detectar cualquier actividad no autorizada en sus cuentas. También la utilizamos para comunicarnos con usted sobre los productos que está utilizando actualmente, sus solicitudes de atención al cliente, nuevos productos que puedan gustarle, oportunidades para que nos proporcione comentarios y actualizaciones de políticas.',
    rightsTitle: 'Sus Derechos',
    rightsText: 'El Espacio Económico Europeo (EEE) establece ciertos derechos para los sujetos de datos (incluyendo acceso, rectificación, eliminación, restricción del procesamiento, portabilidad de datos, y el derecho a objetar y quejarse). Blue Visibility Tech se compromete a proporcionarle los mismos derechos, sin importar dónde elija vivir.',
    rightsCards: [
      { title: 'Derecho de Acceso', text: 'Obtener confirmación y acceso a sus datos personales' },
      { title: 'Derecho de Rectificación', text: 'Corregir datos personales inexactos' },
      { title: 'Derecho de Supresión', text: 'Solicitar la eliminación de sus datos personales' },
      { title: 'Derecho de Portabilidad', text: 'Transferir su información a un tercero' }
    ],
    retentionTitle: 'Retención de Datos',
    retentionText: 'Conservamos su información personal durante el período necesario para los fines establecidos en esta política de privacidad. Cuando ya no tengamos una necesidad legítima de procesar su información, eliminaremos, anonimizaremos o aislaremos su información, según corresponda.',
    retentionNoteLabel: 'Eliminación de cuenta:',
    retentionNote: 'Después de terminar su cuenta, sus datos se eliminarán automáticamente de nuestra base de datos activa en 6 meses y de nuestras copias de seguridad en 3 meses después de esa fecha.',
    securityTitle: 'Seguridad de la Información',
    securityText: 'En Blue Visibility Tech, nos tomamos la seguridad de los datos muy en serio. Tomamos medidas para implementar salvaguardas administrativas, técnicas y físicas apropiadas para prevenir el acceso no autorizado, uso, modificación, divulgación o destrucción de la información que nos confía.',
    contactTitle: 'Contacto',
    contactText: 'Siempre puede contactarnos para hacer preguntas sobre nuestras prácticas de privacidad, solicitar un Acuerdo de Procesamiento de Datos compatible con GDPR, alertarnos si cree que hemos recopilado datos personales de un menor, o solicitar que su información personal sea eliminada de nuestros blogs o foros.',
    emailLabel: 'Email:',
    contactAddress: 'Delegado de Protección de Datos, Blue Visibility Tech S.L.U., Calle Princesa 31, 2º Madrid',
    updatesTitle: 'Notificación de Cambios',
    updatesText: 'Podemos modificar la política de privacidad en cualquier momento, con notificación previa a través de un anuncio de servicio o enviando un correo electrónico a su dirección de correo electrónico principal. Si realizamos cambios significativos a la política de privacidad que afecten sus derechos, recibirá una notificación sobre los cambios al menos 30 días antes por correo electrónico.',
    lastUpdated: 'Última actualización: 25 de febrero de 2022',
  },
  en: {
    title: 'Privacy Policy',
    effective: 'Effective as of 25 February 2022',
    summaryTitle: 'Summary of Our Privacy Policy',
    summaryText: 'This is a summary of our new privacy policy, which applies to all Cadenia websites linked here and to all products and services offered on those websites. The detailed policy follows the same structure as this summary and constitutes the actual legal document.',
    commitmentTitle: 'Our Commitment to Privacy',
    commitmentText: 'Blue Visibility Tech (Cadenia brand) has never sold your information to third parties for advertising purposes, nor do we earn revenue by displaying third-party ads to you. We have no intention of doing so in the future. This policy explains what information we collect from you, what we do with it, who can access it and what you can do about it.',
    controllerTitle: 'Data Controller',
    controllerIdentityLabel: 'Identity and contact details of the data controller:',
    controllerIdentity: 'Blue Visibility Tech S.L.U. Tax ID (NIF) B09726571',
    addressLabel: 'Address:',
    controllerAddress: 'Calle Princesa 31, 2º Madrid',
    dpoLabel: 'Contact details of the Data Protection Officer:',
    dpoName: 'Jesús Santín',
    part1Title: 'Part I – Information Blue Visibility Tech Collects and Controls',
    collectTitle: 'What Information Blue Visibility Tech Collects',
    collectText: 'We only collect the information we actually need. Some of this information is data you actively provide to us when you register an account, sign up for an event, request customer support or carry out a technical data integration. We store your name and contact information, but we do not store credit card numbers (except with your permission and in one of our secure payment portals).',
    providedTitle: 'Information You Provide to Us',
    providedItems: [
      { label: 'Account Registration:', text: 'Name, contact number, email address, company name and country' },
      { label: 'Event Registrations:', text: 'Information submitted when registering for events, subscribing to newsletters or downloading materials' },
      { label: 'Payment Information:', text: 'Name, contact information and credit card or bank account details' },
      { label: 'Testimonials:', text: 'Name and other personal information when you authorize testimonials' }
    ],
    autoTitle: 'Information We Collect Automatically',
    autoItems: [
      { label: 'Browser and Device Information:', text: 'IP address, browser type, language preference, time zone' },
      { label: 'Cookies and Tracking Technologies:', text: 'To identify users and improve the user experience' },
      { label: 'Application Logs:', text: 'Information about how users use our products and services' }
    ],
    usageTitle: 'What We Do with Your Information',
    usageText: 'We use your information to provide the services you requested, create and maintain your accounts, and detect any unauthorized activity on your accounts. We also use it to communicate with you about the products you are currently using, your customer support requests, new products you may like, opportunities to give us feedback, and policy updates.',
    rightsTitle: 'Your Rights',
    rightsText: 'The European Economic Area (EEA) grants data subjects certain rights (including access, rectification, erasure, restriction of processing, data portability, and the right to object and to lodge a complaint). Blue Visibility Tech is committed to providing you with the same rights, regardless of where you choose to live.',
    rightsCards: [
      { title: 'Right of Access', text: 'Obtain confirmation of and access to your personal data' },
      { title: 'Right of Rectification', text: 'Correct inaccurate personal data' },
      { title: 'Right of Erasure', text: 'Request the deletion of your personal data' },
      { title: 'Right of Portability', text: 'Transfer your information to a third party' }
    ],
    retentionTitle: 'Data Retention',
    retentionText: 'We retain your personal information for the period necessary for the purposes set out in this privacy policy. When we no longer have a legitimate need to process your information, we will delete, anonymize or isolate it, as appropriate.',
    retentionNoteLabel: 'Account deletion:',
    retentionNote: 'After you terminate your account, your data will be automatically deleted from our active database within 6 months, and from our backups within 3 months after that date.',
    securityTitle: 'Information Security',
    securityText: 'At Blue Visibility Tech, we take data security very seriously. We take steps to implement appropriate administrative, technical and physical safeguards to prevent unauthorized access, use, modification, disclosure or destruction of the information you entrust to us.',
    contactTitle: 'Contact',
    contactText: 'You can always contact us to ask questions about our privacy practices, request a GDPR-compliant Data Processing Agreement, alert us if you believe we have collected personal data from a minor, or request that your personal information be removed from our blogs or forums.',
    emailLabel: 'Email:',
    contactAddress: 'Data Protection Officer, Blue Visibility Tech S.L.U., Calle Princesa 31, 2º Madrid',
    updatesTitle: 'Notification of Changes',
    updatesText: 'We may modify the privacy policy at any time, with prior notice through a service announcement or by sending an email to your primary email address. If we make significant changes to the privacy policy that affect your rights, you will receive notice of the changes at least 30 days in advance by email.',
    lastUpdated: 'Last updated: 25 February 2022',
  },
};

const Privacy = () => {
  const t = useT(T);
  return (
    <div className="pt-20">
      <PageSEO title={t.title} description={t.summaryText} />
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-light text-gray-900 mb-6">
            {t.title}
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            {t.effective}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-12 border border-gray-200">

            {/* Summary */}
            <div className="mb-12">
              <h2 className="text-2xl font-light text-gray-900 mb-6">{t.summaryTitle}</h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                {t.summaryText}
              </p>
            </div>

            {/* Commitment */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.commitmentTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.commitmentText}
              </p>
            </div>

            {/* Data Controller */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.controllerTitle}</h3>
              <div className="bg-gray-50 p-6 border border-gray-200">
                <p className="text-gray-700 mb-2">
                  <strong>{t.controllerIdentityLabel}</strong> {t.controllerIdentity}
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>{t.addressLabel}</strong> {t.controllerAddress}
                </p>
                <p className="text-gray-700">
                  <strong>{t.dpoLabel}</strong> {t.dpoName}
                </p>
              </div>
            </div>

            {/* Part I */}
            <div className="mb-12">
              <h2 className="text-2xl font-light text-gray-900 mb-6">{t.part1Title}</h2>

              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.collectTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {t.collectText}
              </p>

              <h4 className="text-lg font-medium text-gray-900 mb-3">{t.providedTitle}</h4>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
                {t.providedItems.map((item, i) => (
                  <li key={i}><strong>{item.label}</strong> {item.text}</li>
                ))}
              </ul>

              <h4 className="text-lg font-medium text-gray-900 mb-3">{t.autoTitle}</h4>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
                {t.autoItems.map((item, i) => (
                  <li key={i}><strong>{item.label}</strong> {item.text}</li>
                ))}
              </ul>
            </div>

            {/* Usage */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.usageTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.usageText}
              </p>
            </div>

            {/* Rights */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.rightsTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.rightsText}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {t.rightsCards.map((card, i) => (
                  <div key={i} className="bg-gray-50 p-4 border border-gray-200">
                    <h4 className="font-medium text-gray-900 mb-2">{card.title}</h4>
                    <p className="text-sm text-gray-600">{card.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Retention */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.retentionTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.retentionText}
              </p>
              <div className="bg-blue-50 p-4 border border-blue-200">
                <p className="text-blue-800 text-sm">
                  <strong>{t.retentionNoteLabel}</strong> {t.retentionNote}
                </p>
              </div>
            </div>

            {/* Security */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.securityTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.securityText}
              </p>
            </div>

            {/* Contact */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.contactTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.contactText}
              </p>
              <div className="bg-gray-50 p-6 border border-gray-200">
                <p className="text-gray-700 mb-2">
                  <strong>{t.emailLabel}</strong> contact@cadenia.eu
                </p>
                <p className="text-gray-700">
                  <strong>{t.addressLabel}</strong> {t.contactAddress}
                </p>
              </div>
            </div>

            {/* Updates */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.updatesTitle}</h3>
              <p className="text-gray-600 leading-relaxed">
                {t.updatesText}
              </p>
            </div>

            {/* Footer */}
            <div className="border-t border-gray-200 pt-8">
              <p className="text-sm text-gray-500">
                {t.lastUpdated}
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;